import { magicLinkClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

const API_BASE = (import.meta.env.VITE_API_URL as string | undefined) ?? 'https://api.ohear.ai'
const VERSION_OVERRIDE = import.meta.env.VITE_CF_WORKER_VERSION_OVERRIDE as string | undefined

export const authClient = createAuthClient({
  baseURL: API_BASE,
  basePath: '/api/auth',
  fetchOptions: {
    credentials: 'include',
    headers: VERSION_OVERRIDE
      ? { 'Cloudflare-Workers-Version-Overrides': `ohear-api="${VERSION_OVERRIDE}"` }
      : undefined,
  },
  plugins: [magicLinkClient()],
})
